import moment from 'moment';

/** Screenshot-style PDF of a rendered page region (single tall page). Captures
 * the live DOM, so whatever filters/periods are currently selected on screen
 * are exactly what ends up in the file. Elements tagged
 * `data-html2canvas-ignore` (e.g. the per-card Excel buttons) are left out. */
export async function exportElementToPdf(node: HTMLElement, filenameBase: string): Promise<void> {
    const [{ default: html2canvas }, { default: jsPDF }] = await Promise.all([
        import('html2canvas'),
        import('jspdf'),
    ]);
    // Keep the raster under browsers' max canvas size on very tall pages.
    const scale = Math.max(1, Math.min(2, 14000 / Math.max(node.scrollHeight, 1)));
    const canvas = await html2canvas(node, { backgroundColor: '#000000', scale, useCORS: true });
    const width = canvas.width / scale;
    const height = canvas.height / scale;
    const pdf = new jsPDF({ orientation: width > height ? 'l' : 'p', unit: 'px', format: [width, height], compress: true });
    pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, 0, width, height);
    pdf.save(`${filenameBase}-${moment().format('YYYY-MM-DD')}.pdf`);
}
